import React,{ useEffect, useState } from "react"
import { Table,Button } from "reactstrap";
import TableRowsTask from "./TableRowsTask";
import moment from "moment";
import Notifications from "../../components/common/Notifications";
import "../../style/calendarclass.css";
import api from "../../apis/api";
var curr = new Date; 
// let allowedDates=[];
// const dates = [];
// const t =new Date(curr.setDate(curr.getDate() - curr.getDay()+1)).getDate();
// let lastFridayl = new Date();
// lastFridayl.setDate(t); 
//       let fromDate =new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
//       // let fromDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
//       let toDate =  new Date();
//       toDate.setDate(toDate.getDate() + 7);;
//       // var dateParts = fromDate.split("-");
//       // var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
//       // lastFriday = jsDate;
//       let range= getDatesInRange(fromDate,toDate,lastFridayl);
//       allowedDates=range;

//       function getDatesInRange(startDate, endDate,lastFriday) {
//         const date = new Date(startDate);
//         const datela=new Date(lastFriday);
//         const endlast=new Date(lastFriday.setMonth(lastFriday.getMonth() + 12));
     
//        while (date <= new Date(endDate)) {
//          dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
//          date.setDate(date.getDate() + 1);
//        }
//        while(datela <= new Date(endlast))
//        {
//          dates.push(moment(new Date(datela)).format("YYYY-MM-DD"));
//          datela.setDate(datela.getDate() + 1);
//        }
     
//        return dates;
//      }

const loginUser = JSON.parse(localStorage.getItem("user"));
function AddDeleteTableRowsTask({setData,tasktrackList,handletotcal,allowedDates,datearray,datearraylast,unlockReqList,datearraylastAll,addOrEdit,handledatepicker,LeaveReq,handleAlreadyLeave,LeaveReqList,datearraylastdisable,handledisable,dutytypeList,holidaylist,createdDate,handlestatuschange,plannedLeaveList,isFormDisabled}){
  const [height, setHeight] = useState(100); // Starting with 100px height
    const [rowsData, setRowsData] = useState([]);
    const [error, setError] = useState(null);
    const [autoDutyType, setAutoDutyType] = useState(0);
    const [duration, SetDuration] = useState(0);
      const AC_DUTY_TYPE_ID = dutytypeList.find(d => d.type === "Attendance Compensation")?.dutyTypeId;
  const inputDateFormatString = (workDate)=>{
      var year = workDate.getFullYear();
      var month = workDate.getMonth() + 1;
      if(month <= 9)
          month = '0'+month;
      var day= workDate.getDate();
      if(day <= 9)
          day = '0'+day;
          var prettyDate = year +'-'+ month +'-'+ day;
          return prettyDate;
    };
    const getSafeAbsentDate = (absentDateVal) => {
      if (!absentDateVal) return null;
      const d = new Date(absentDateVal);
      if (isNaN(d.getTime()) || d.getFullYear() <= 1900) {
        return null;
      }
      return inputDateFormatString(d);
    };
    useEffect(()=>{
      setRowsData([]);
      if(addOrEdit === "add")
        {
          setHeight(100);
          if(tasktrackList!=null && tasktrackList.length>0){
            let arry = [];
           for(var i=0;i<tasktrackList.length;i++) {
               
                var rowsInput = {
                  timesheetStatusId:tasktrackList[i].timesheetStatusId ,
                    startdate: tasktrackList[i].statusDate,
                    absentdate: getSafeAbsentDate(tasktrackList[i].absentDate),
                    hoursspent:tasktrackList[i].hoursLogged,
                    hoursbillable:tasktrackList[i].hoursBillable,
                    description:tasktrackList[i].description,
                    status : tasktrackList[i].status
                   
                }
                arry.push(rowsInput);
               
            }
            setRowsData([...rowsData,...arry])
            // if(rowsData.length>0){
            //     let finalOutput = rowsData.filter((value, index, self) =>
            //     index === self.findIndex((t) => (
            //         t.timesheetStatusId == value.timesheetStatusId
            //     )))           
    
            // setRowsData(finalOutput)
            // }
            
        }
        else
        {
           const defaultRow = {
      startdate: '',
      absentdate: '',
      hoursspent: '',
      status: '',
      hoursbillable: '',
      dutyTypeId: '',
      description: ''
    };
    setRowsData([defaultRow]);
        }
        }
        else
        {
          const count=tasktrackList.length;

          setHeight(100 +(count*50));
          if(tasktrackList!=null && tasktrackList.length>0){
            let arry = [];
           for(var i=0;i<tasktrackList.length;i++) {
               
                var rowsInput = {
                  timesheetStatusId:tasktrackList[i].timesheetStatusId ,
                    startdate: tasktrackList[i].statusDate,
                    absentdate: getSafeAbsentDate(tasktrackList[i].absentDate),
                    hoursspent:tasktrackList[i].hoursLogged,
                    hoursbillable:tasktrackList[i].hoursBillable,
                    dutyTypeId:tasktrackList[i].dutyTypeId ,
                    description:tasktrackList[i].description,
                    status : tasktrackList[i].status
                   
                }
                arry.push(rowsInput);
               
            }
            setRowsData(arry);
            // if(rowsData.length>0){
            //     let finalOutput = rowsData.filter((value, index, self) =>
            //     index === self.findIndex((t) => (
            //         t.timesheetStatusId == value.timesheetStatusId
            //     )))           
    
            // setRowsData(finalOutput)
            // }
            
        }
        else
        {
          setRowsData([]);
        }
        }
      
      
    },[tasktrackList,setRowsData]);
    
const addTableRows = React.useCallback(() => {
    const rowsInput = {
        startdate: '',
        hoursspent: '',
        status: '',
        hoursbillable: '',
        dutyTypeId: '', 
        description: '',
        goalAchievedId: 0,
        absentdate: '',
    };

    setRowsData(prevRows => {
        const newRows = [rowsInput, ...prevRows];
        setData(newRows);  // update parent with latest rows
        return newRows;
    });

    setHeight(prevHeight => prevHeight + 50);

    if (rowsData.length <= 1) {
        handledisable(0);
    }
}, [setHeight, setData, rowsData, handledisable]);

   const deleteTableRows = (e,index)=>{
        e.preventDefault();
        const rows = [...rowsData];
        const delrow= rows[index];
        rows.splice(index, 1);
        setRowsData(rows);
        setData(rows);
        // deldata(delrow);
   }
 
   const handleChange = (index, evnt)=>{    
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];

   
  if ((name === "hoursspent" || name === "hoursbillable") && Number(value) < 0) {
    rowsInput[index][name] = 0; 
  } else {
    rowsInput[index][name] = value;
  }

    setRowsData(rowsInput);  
    setData(rowsInput);
      var sumofall=0;
      rowsInput.forEach(element => {
        sumofall=sumofall+parseFloat(element.hoursspent === '' ? 0 : element.hoursspent);
       });

       var sumofallbillable=0;
       rowsInput.forEach(element => {
        sumofallbillable=sumofallbillable+parseFloat(element.hoursbillable === '' ? 0 : element.hoursbillable);
        });
       handletotcal(name,name==="hoursspent" ? sumofall : sumofallbillable);

  }
  function isInArray(LeaveReq, value) {
    const newlist=LeaveReq.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value);
    return newlist;  
  }
  const handleChangeDate = (index, evnt,nametite,createdDate)=>{ 

    const selectedDate = new Date(evnt);
    const taskCreatedDate = new Date(createdDate);

    if (selectedDate < taskCreatedDate) {
        setError(`Start Date cannot be earlier than task created date: ${moment(createdDate).format('YYYY-MM-DD')}`);
        return; // stop further processing
    } 
 
const fetchapi=async () =>{ 
     const gg=LeaveReqList;
    let typevalue=0;
    const value1=moment(evnt).format('YYYY-MM-DD');
    const status=isInArray(LeaveReqList, value1);
         const result=  await api.dbAttendance().getduration(parseInt(loginUser.EmployeeId),value1);
                   if(result.data.duration == '00:00:00')
                    {
                      var type=dutytypeList.filter((el) => el.type === "Work From Home");
                      setAutoDutyType(type[0].dutyTypeId);
                      typevalue= type[0].dutyTypeId;  
                      handlestatuschange(0);
                    }
                    else{
                      var type=dutytypeList.filter((el) => el.type === "Work From Office");
                      setAutoDutyType(type[0].dutyTypeId);
                      typevalue=type[0].dutyTypeId;
                        const [hours, minutes, seconds] = result.data.duration.split(":").map(Number);
                         const minute= hours * 3600 + minutes * 60 + seconds;
                      handlestatuschange(result.data.duration);
                    }
                    const name =  nametite; 
                    const  value  = evnt;
                    const rowsInput = [...rowsData];
                    rowsInput[index][nametite] = evnt;
                    rowsInput[index]['dutyTypeId'] = typevalue;
                    setRowsData(rowsInput);  
                 
                    setData(rowsInput);
                    handledatepicker();
                  }
                  fetchapi();
      
    // const value1=moment(evnt).format('YYYY-MM-DD');
    // const status=isInArray(LeaveReq, value1);
    
      
  }
  const handleChangeDateSel = (index, evnt,nametite)=>{ 
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);  
    setData(rowsInput);
    handletotcal(name,value);
  }
  const handleChangeTypeSel = (index, evnt,nametite)=>{ 
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    
  
  // ✅ Check if selected dutytype matches
  if (parseInt(value) === AC_DUTY_TYPE_ID) {
    console.log("Attendance Compensation selected");
    // Ensure absentdate exists and is valid (not 0001-01-01, empty, or year <= 1900)
    const absD = rowsInput[index].absentdate;
    const isInvalid = !absD || absD === '' || absD.startsWith('0001') || new Date(absD).getFullYear() <= 1900;
    if (isInvalid) {
      rowsInput[index].absentdate = inputDateFormatString(new Date());
    }
  } else {
    // Optional: clear absentdate
    rowsInput[index].absentdate = '';
  }
    rowsInput[index][name] = value;
    setRowsData(rowsInput);  
    setData(rowsInput);
    handletotcal(name,value);
  }
  
 

    return(
      
            <div className="row">
                <div className="col-sm-12">
                <div style={{width :"943px" , height:"400px" }}>
                <Table>
                    <thead className="performance-table">
                      <tr>
                          <th>Start Date</th>
                        
                          <th>Hours Spent</th>
                          <th>Hours Billable</th>
                          <th>Duty Type</th>
                          <th>Status</th>
                          <th>
    {rowsData.some(r => r.dutyTypeId == AC_DUTY_TYPE_ID) ? 'Absent Date' : '\u00A0'}
</th>
                          <th>Description</th>
                           
                     {addOrEdit == 'add' ?
                     (<th><Button style={{backgroundColor:"transparent"}} 
                     className="btn-admin-settings btn" 
                     disabled={true} onClick={(e) => addTableRows(e)} >+</Button></th>) : 
                     (<th><Button style={{backgroundColor:"transparent"}} 
                     className="btn-admin-settings btn" onClick={(e) => addTableRows(e)}  disabled={isFormDisabled} >+</Button></th>)}     
                      </tr>
                    </thead>
                    <tbody>
                   <TableRowsTask rowsData={rowsData} 
                 handleChange={handleChange}
                 allowedDates={allowedDates}
                 handleChangeDate={handleChangeDate}
                 handleChangeDateSel={handleChangeDateSel}
                 handleChangeTypeSel={handleChangeTypeSel}
                 deleteTableRows={deleteTableRows}
                 datearray={datearray}
                 datearraylast={datearraylast}
                 unlockReqList={unlockReqList}
                 datearraylastAll={datearraylastAll}
                 datearraylastdisable={datearraylastdisable}
                 dutytypeList={dutytypeList}
                  autoDutyType={autoDutyType}
                  holidaylist={holidaylist}
                  createdDate={createdDate} 
                  isFormDisabled={isFormDisabled} 
                   />
                   </tbody> 
                </Table> 
                </div>
                </div>
                <div className="col-sm-4">
                </div>
                <Notifications notifications={error}></Notifications>
            </div>
            
    )

}
export default AddDeleteTableRowsTask